import { Component, HostListener, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { AppUtility } from 'src/app/interceptor/apputitlity';
declare var Razorpay: any;

@Component({
  selector: 'app-how-it-works',
  templateUrl: './how-it-works.component.html',
  styleUrls: ['./how-it-works.component.scss'],
  providers: [MessageService]
})
export class HowItWorksComponent implements OnInit {
  statusDetail: { status: string; payment_id: any; razorpay_signature: any; description: string; };
  screenshot: any;

  loaderCheck: boolean = false

  constructor(private _apiService: ApiService, private utility: AppUtility, private messageService: MessageService, private router: Router, private commonFunction: AppUtility) { }

  bookingData: any = { countryId: 1, payMode: 'online', paymentType: '', bookingQuantity: 1, passenger: [{ passengerName: '', companyId: '', passengerPassport: null }] };

  imageCheck: boolean = false;

  country: any = [];

  displayModal: boolean = false;

  acceptTerms: boolean = false;

  tableData: any = [{ name: 'Magic 2026 Booking', price: 17200, Quantity: 1, Total: 172001 }]
  bookingQuantity = 4;

  ngOnInit() {
    this.getEventAmountAgainstUpline()
    // this.router.navigateByUrl('/');
    this.bookingData = { countryId: 1, payMode: 'online', paymentType: '', bookingQuantity: 1, passenger: [{ passengerName: '', companyId: '', passengerPassport: '' }] };
    if (localStorage.getItem('otherDetail')) {
      let details = JSON.parse(localStorage.getItem('otherDetail'));
      // if(details) {
      this.tableData[0].price = details.price;
      this.tableData[0].name = details.name;
      // }
    }
    else {
      this.tableData = [{ name: 'Magic 2026 Booking', price: 17200, Quantity: 1, Total: 17200 }]
    }
    localStorage.removeItem('data');
    localStorage.removeItem('mode');
    localStorage.removeItem('bookingID');
    localStorage.removeItem('bookingDetails');
    this._apiService.getAllCountry().then((res: any) => {
      // console.log(res);
      this.country = res?.returnValue;
    })
  }

  onChange(event: any) {
    if (event.target.checked) {
      this.acceptTerms = true;
    }
    else {
      this.acceptTerms = false;
    }
  }

  onClick(event: any) {
    console.log(event.target.value);
    if (!(event.target.value > 0 && event.target.value < 31)) {
      this.bookingData.bookingQuantity = ''
    }
  }

  async signUp(form: NgForm) {
    // alert(this.tableData[0].Total);
    // console.log(form.value);
    // this.bookingData.amount = ;
    if(this.bookingData.bookingQuantity == 0) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Booking quantity must be greater then zero!',
      });
      return;
    }
    let object = {
      amount: Number(this.tableData[0].Total * 100)
      // amount : Number(1000)
    }
    
    
    if (this.acceptTerms) {
      if (form.valid) {
        let data = JSON.parse(localStorage.getItem('uplineData'));
        this.bookingData.upLineId = Number(data?.upline);
        this.bookingData.downLineId = Number(data?.downline ?? 0);
        this.bookingData.contactNumber = String(this.bookingData.contactNumber);
        this.bookingData.pinCode = String(this.bookingData?.pinCode ?? '313001');
        this.bookingData.amount = Number(this.tableData[0].Total);
        this.bookingData.price = Number(this.tableData[0].price);
        this.bookingData.totalPrice = Number(this.tableData[0].Total);
        if (this.bookingData.upLineId) {
          if (this.bookingData.payMode == 'online') {
            let orderId: any
            // this.commonFunction.loader(true);
            this.loaderCheck = true;
            this.createCustomerBooking();
            // await this._apiService.confirmBooking(object).then((res: any) => {
              
            //   // this.commonFunction.loader(false);
            //   this.loaderCheck = false;
            //   orderId = res.orderId;
            //   this.payment(orderId, Number(this.tableData.Total))
            // })
          }
          else {
            this.statusDetail = {
              status: 'Payment Success',
              payment_id: '',
              razorpay_signature: '',
              description: 'Payment Success',
            };
            this.createCustomerBooking();
          }
        }
        else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Something Went Worng!',
          });
          setTimeout(() => {
            this.router.navigateByUrl('/');
          }, 1500);
        }
      }
      else {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Please Fill All the Details!',
        });
      }
    }
    else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please Accept Terms & Conditions!',
      });
    }
  }

  getTotalAmount() {
    if (this.bookingData?.bookingQuantity > this.bookingData?.passenger?.length) {
      let count = (this.bookingData?.bookingQuantity) - (this.bookingData?.passenger?.length);
      for (let i = 0; i < count; i++) {
        this.bookingData.passenger.push({ passengerName: '', companyId: '', passengerPassport: '' })
      }
    }
    else {
      let count = this.bookingData?.passenger?.length - this.bookingData.bookingQuantity;
      this.bookingData.passenger.splice(-count, (this.bookingData?.passenger?.length));
    }
    this.tableData[0].Quantity = this.bookingData.bookingQuantity;
    this.tableData[0].Total = Number(this.bookingData.bookingQuantity) * Number(this.tableData[0].price);
  }

  payment(orderId: string, amount: number): void {
    let options = {
      key: 'rzp_live_bDo6gdxtqwRAn9',
      amount: amount,
      name: 'Event',
      description: 'Event Booking',
      image: '',
      order_id: orderId,
      handler: function (response: any) {
        var event = new CustomEvent('payment.success', {
          detail: response,
          bubbles: true,
          cancelable: true,
        });
        window.dispatchEvent(event);
      },
      prefill: {
        name: '',
        email: '',
        contact: '',
      },
      notes: {
        address: '',
      },
      theme: {
        color: '#3399cc',
      },
    };

    var rzp1 = new Razorpay(options);
    rzp1.open();

    rzp1.on('payment.failed', (response: any) => {
      let statusDetail = {
        status: 'Payment Success',
        payment_id: response.error.metadata.payment_id,
        razorpay_signature: '',
        description: response.error.description,
      };
    });
  }

  @HostListener('window:payment.success', ['$event'])
  async onPaymentSuccess(event: any): Promise<void> {
    this.statusDetail = {
      status: 'Payment Success',
      payment_id: event.detail.razorpay_payment_id,
      razorpay_signature: event.detail.razorpay_signature,
      description: 'Payment Success',
    };
    this.createCustomerBooking();
  }

  async createCustomerBooking() {
    let data = JSON.parse(localStorage.getItem('uplineData'));

    let formData = new FormData();

    formData.append('UpLineId', JSON.parse(data.upline))
    if (data?.downline) {
      formData.append('DownLineId', JSON.parse(data?.downline))
    }
    else {
      formData.append('DownLineId', JSON.parse('0'))
    }
    formData.append('CustomerName', "customer name")
    formData.append('BookingQuantity', JSON.parse(this.bookingData.bookingQuantity))
    formData.append('EmailAddress', this.bookingData.emailAddress)
    formData.append('ContactNumber', this.bookingData.contactNumber)
    formData.append('PayMode', this.bookingData.payMode)
    formData.append('Price', this.tableData[0].price)
    formData.append('TotalPrice', this.tableData[0].Total)
    formData.append('Amount', this.tableData[0].price)
    let passengerName = '';
    let companyId = '';
    for (let index = 0; index < this.bookingData.passenger.length; index++) {
      const element = this.bookingData.passenger[index];
      formData.append(`filePaths` , element.passengerPassport);
      passengerName = passengerName + ((passengerName && element.passengerName) ? ',' : '') + element.passengerName;
      companyId = companyId + ((companyId && element.companyId) ? ',' : '') + element.companyId;
    }
    // formData.append('OrderNo', this.statusDetail.payment_id);
    this.bookingData.passenger.forEach(passenger => {
      delete passenger.passportDoc; 
      delete passenger.passengerPassport
    });
    
    formData.append('passengerName' , passengerName);
    formData.append('companyId' , companyId);
    formData.append('IRIDNo', this.bookingData?.yourId)
    
    localStorage.setItem('returnPrimaryValue', this.bookingData.payMode);
    formData.append('IsApproved', (this.bookingData.payMode == 'online') ? JSON.parse('true') : JSON.parse('false'))
    if (this.bookingData.payMode == 'offline') {
      formData.append('PaymentType', this.bookingData.paymentType)
      formData.append('Document', this.screenshot)
    }
    else{
      formData.append('isApproved', '1');
    }
    
    if (this.bookingData.upLineId) {
      this.loaderCheck = true;
      // this.commonFunction.loader(true);
      await this._apiService.customerBooking(formData).then((res: any) => {
        // console.log(res);
        // alert('booking created')
        if (res.success) {
          localStorage.setItem('amount', JSON.stringify(this.bookingData?.amount))
          localStorage.setItem('mode', this.bookingData.payMode);
          localStorage.setItem('returnPrimaryValue', res.returnValue);
          // this.router.navigateByUrl('receipt/' + res.returnValue);

          //got error so redirect before

          if (res.returnValue) {
            let object = {
              transactionalId: JSON.stringify(this.statusDetail),
              customerBookingId: res?.returnValue,
              customerName: this.bookingData?.customerName,
              iridNo: this.bookingData?.yourId,
              emailAddress: this.bookingData?.emailAddress,
              totalPrice: this.bookingData?.amount,
              orderNo: this.statusDetail?.payment_id,
              IsApproved: true
            }
            console.log("object",object);
            localStorage.setItem('retrunBookingOnlineDetails', JSON.stringify(object));
            if (this.bookingData.payMode == 'offline') {
              // this.commonFunction.loader(false);
              this.loaderCheck = false;
              this.router.navigateByUrl('receipt/' + res.returnValue);
            }
            else {
              let paymentData = {
                Amount: String(this.tableData[0].Total),
                CustomerName: String(this.bookingData.contactNumber),
                CustomerEmail: this.bookingData.emailAddress,
                productinfo: "Tour and Travels",
                phone: this.bookingData.contactNumber,
              };
              this._apiService.makePayment(paymentData).subscribe(
                (info) => {
                  console.log('Payment successful:', info.txnid);
                  console.log('Payment successful:', info);
                  let htmlbody = `
                    <html>
                    <head></head>
                    <body>
                    <form action="${info.payu_url}" method="post" id="payu_form">
                      <input type="hidden" name="firstname" value="${info.firstname}"/>
                      <input type="hidden" name="email" value="${info.email}"/>
                      <input type="hidden" name="phone" value="${info.mobile}"/>
                      <input type="hidden" name="surl" value="${info.surl}"/>
                      <input type="hidden" name="curl" value="${info.furl}"/>
                      <input type="hidden" name="key" value="${info.merchant_key}"/>
                      <input type="hidden" name="hash" value="${info.hash}"/>
                      <input type="hidden" name="txnid" value="${info.txnid}"/>
                      <input type="hidden" name="productinfo" value="${info.productinfo}"/>
                      <input type="hidden" name="amount" value="${info.amount}"/>
                      <button type="submit" value="submit" id="submitBtn"></button>
                  </form>
                      <script type="text/javascript">document.getElementById("payu_form").submit();</script>
                  </body>
                 </html>`
                  console.log(htmlbody);
                  const winUrl = URL.createObjectURL(
                    new Blob([htmlbody], { type: "text/html" })
                  );
               
                  window.location.href = winUrl;
                },
                (error) => {
                  console.error('Payment failed:', error);
  
                  this.commonFunction.loader(false);
                  // Handle error
                }
              );

            }
          }
        }
      })
    }
    else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Something Went Worng!',
      });
    }
  }

  onPaymentClick() {
    if (this.bookingData.payMode == 'offline') {
      console.log(this.bookingData.payMode)
      this.imageCheck = true;
    }
    else if (this.bookingData.payMode == 'online') {
      console.log(this.bookingData.payMode)
      this.imageCheck = false
    }
  }

  uploadedFiles: any = [];
  onImageClick(event: any, string?: any , index?:any) {
    console.log(typeof (JSON.parse('1')))
    let object = {};
    if (string == 'ss') {
      this.screenshot = event.target.files[0];
    }
    else {
      this.bookingData.passenger[index].passengerPassport = event.target.files[0];
    }
  }

  getEventAmountAgainstUpline() {
    let data = JSON.parse(localStorage.getItem('uplineData'));
    if (!data.upline || !data.downline) {
      this.router.navigateByUrl('/customerBooking')
    }
    let object = {
      Mode: 'upline'
    }
    this.utility.loader(true);
    this._apiService.uplinePost(object).then((res: any) => {
      if (res.success) {
        let uplineobj = res.returnValue.find(resp => resp.id == data.upline);
        this.tableData[0].price = uplineobj.emailAddress.split("&")[0];
        this.tableData[0].Total = uplineobj.emailAddress.split("&")[0];
      }
    })
    this.utility.loader(false);
  }
}